import { useMemo, useState } from 'react';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

interface RawJsonRendererProps {
  data: unknown;
  className?: string;
}

const toPrettyJson = (data: unknown): string => {
  try {
    return JSON.stringify(data, null, 2);
  } catch {
    return String(data);
  }
};

export const RawJsonRenderer = ({ data, className }: RawJsonRendererProps) => {
  const [copied, setCopied] = useState(false);
  const text = useMemo(() => toPrettyJson(data), [data]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      console.error('Failed to copy JSON:', error);
    }
  };

  return (
    <div className={cn('rounded-lg border border-gray-200 bg-gray-50', className)}>
      <div className="flex items-center justify-between border-b border-gray-200 px-3 py-2">
        <span className="text-xs font-medium text-gray-500">Donnée brute</span>
        <Button variant="ghost" size="sm" onClick={handleCopy}>
          {copied ? 'Copié' : 'Copier'}
        </Button>
      </div>
      <pre className="max-h-80 overflow-auto p-3 text-xs text-gray-700">{text}</pre>
    </div>
  );
};
